<router-outlet />
<!-- NuSI assistant: on every signed-in page -->
<app-nuai-chat />
